import {call, put, takeLatest} from 'redux-saga/effects'
import {getNews, setNews, setError, loadDismissedIds} from './AnnouncementRedux'
import {getNewsRequest} from './AnnouncementAPI'
import {ResponseGenerator} from '../models/ResponseGenerator'
import {HTTP_CODE} from '../constants'
import {NewsModel} from '../models/NewsModel'

function* getNewsSaga() {
  // try {
  //   // Load dismissed IDs first
  //   yield put(loadDismissedIds())
    
  //   // Make API call
  //   const response: ResponseGenerator = yield call(getNewsRequest)
    
  //   if (response && response.status === HTTP_CODE.SUCCESS) {
  //     const newsData: NewsModel[] = response.data
  //     yield put(setNews(newsData))
  //   } else {
  //     yield put(setError('Failed to load news'))
  //   }
  // } catch (error: any) {
  //   console.error('Failed to fetch news:', error)
  //   const errorMessage = error?.response?.data?.message || error?.message || 'Failed to load announcements'
  //   yield put(setError(errorMessage))
  // }
}

export default function* announcementSaga() {
  yield takeLatest(getNews.type, getNewsSaga)
}
